// Fallback rendered by ErrorBoundary when any descendant component throws
// during render. Plain text + reload button — kept intentionally minimal so
// it survives even when the rest of the bundle is broken (no third-party
// styling, no router, no query client). Inline styles for the same reason.
export function AppCrashFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h1 style={{ marginBottom: '1rem' }}>Что-то пошло не так</h1>
      <p style={{ marginBottom: '1.5rem', color: '#6b7280' }}>
        Перезагрузите страницу, чтобы продолжить работу.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '0.5rem 1rem',
          borderRadius: '0.375rem',
          border: '1px solid #d1d5db',
          background: '#111827',
          color: '#fff',
          cursor: 'pointer',
        }}
      >
        Перезагрузить
      </button>
    </div>
  )
}
